<template>
  <div>
    <div>
        <v-toolbar flat color="white">
          <v-toolbar-title style="color: #1C2546; margin-top: 40px">Historial Pólizas</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </div>
    <v-toolbar flat color="white">
        <v-divider ></v-divider>
    </v-toolbar>

        <v-row justify="center">
            <v-col col="12" class=" pt-0">
              <v-data-table
                  :headers="headers"
                  :items="polizas"
                  class=""
                >
                  <template v-slot:item.created_at="{item}">
                    {{new Date(item.created_at).toLocaleDateString()}}
                  </template>
                  <template v-slot:item.download="{item}">
                    <v-btn color="success" @click="generarPoliza(item.poliza_file)">
                      <v-icon >mdi-download</v-icon>
                    </v-btn>
                  </template>
              </v-data-table>
            </v-col>
        </v-row>
        
  </div>
</template>
<script>
import axios from 'axios'
export default {
    data: function()  {
        return {
            polizas: [],
            headers: [{text: 'Fecha',value:'created_at'},{text: 'Descargar',value: 'download'}]
        }
    },
    methods: {
      getPolizas() {
        axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/polizas/listado").then(res => {
        this.polizas = res.data;
        });
      },
      generarPoliza(poliza_file){
        try{
            this.mostrar_cargar = true;
            axios({
                url: "https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/polizas/recreate/",
                method: 'POST',
                responseType: 'blob', 
                data: {'poliza':  poliza_file}// important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'file.xlsx');
                document.body.appendChild(link);
                link.click();
            
                this.mostrar_cargar = false;
                
            });
        }catch(error){
          null;
          }
      }
    },
    computed: {
        user() {
      return this.$store.state.user;
    },
    },
    mounted: function () {
        try {
            this.getPolizas()
        } catch (error) {
            null;
        }
    }

}
</script>

<style>

</style>